import { AxiosApi } from "api";
import { FilterOption } from "interface";
import { ReleasePackage } from "interface/package";
import { ApiResponse } from "interface/response";
import { useInfoStore } from "store/error";

export interface ReleasedPackageFilter extends Omit<FilterOption, "vesselRegistrationNumber"> {
    vesselRegistrationId?: string;
    buyerLedgerAccountNumber?: string;
    registrationId?: string;
    vesselId?: string;
    vesselName?: string;
    buyerName?: string;
    terminalId?: string;
    terminalName?: string;
    // buyerId?: string;
}

export async function getReleasedPackagesApi(filter: ReleasedPackageFilter) {
    const apiUri = "ReleasedPackage";
    try {
        //console.log('filter', filter);
        const packages = await AxiosApi.get<ApiResponse<ReleasePackage[]>>(apiUri, { params: filter });
        return packages.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}
